import { clearCache, createCacheKey } from './cache';

/** Clear cached artist profile (Artist Wall reads this after profile edits). */
export function invalidateArtistProfileCache(uid) {
  if (!uid) return;
  clearCache(createCacheKey('artistProfile', { uid }, uid));
}
